import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { MatDialog } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { OtherClinicModel } from 'src/app/models/OtherClinicModel';
import { OtherClinicService } from 'src/app/services/OtherClinicService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { OtherclinicentryComponent } from '../otherclinicentry/otherclinicentry.component';
@Component({
  selector: 'app-other-clinic-tab',
  templateUrl: './other-clinic-tab.component.html',
  styleUrls: ['./other-clinic-tab.component.css'],
})
export class OtherClinicTabComponent implements OnInit {
  patientcode = '';
  clinicdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cliniclocation = '';
  clinicnotes = '';
  docdepartment = '';
  userid = '';
  username = '';
  clinictime = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  Patientname = '';
  chkuser = '' ;


  // Zoom Bottons
    wk_font = 2;
  wk_fontsize = '2ch';


  disablepharnacy = false;

  // Doctors Data
 docCode ='' //// this.storage.retrieve('stgEmpId');
  docName = '';
 docDepartment = '';
  // Tool Bar Text Area Viwe
 editorConfigNoToolbar = {
    editable: false,
    spellcheck: true,
    showToolbar: false,  // 🚫 This hides the toolbar
    height: 'auto',
    frameElement:false,
    minHeight: '0',
    width: '850px',
    placeholder: '',
    translate: 'no',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    toolbarHiddenButtons: []
  };

  // lists
    cliniclocationtext = [];
  otherClinicList : OtherClinicModel []=[];


  constructor(public otherclinic: OtherClinicModel,private dialogref: MatDialog,
                    public storage: LocalStorageService,
                    public otherclinicservice :OtherClinicService,
                    public doctors : DoctorsModel,
                    public doctorsService : DoctorsService,
                    public companyService : CompanyService) {}

  ngOnInit(): void {
     this.patientcode = this.storage.retrieve('stgPatientCode');
      this.Patientname = this.storage.retrieve('stgPatientName');
      this.clinicdate =   formatDate(this.storage.retrieve('stgVisitDate'), 'yyyy-MM-dd', 'en');
      this.RetriveOtherClinic();
      this.RetriveDoctor();
       this.docCode = this.storage.store('stgConsultant',this.docCode);
  }

  RetriveDoctor (){
    this.doctorsService.getdoctors(this.storage.retrieve('stgEmpId'),'1').subscribe((data :DoctorsModel)=>{
      this.docName = data.docName;
      this.docDepartment = data.docDepartment;
      this.storage.store("stgdocDepartment", this.docDepartment)
           })

  }
  ZoomIn(){
      this.wk_font  = this.wk_font  + 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }
    ZoomOut(){
      this.wk_font  = this.wk_font  - 0.5;
      this.wk_fontsize = this.wk_font + 'ch';
    }

    RetriveOtherClinic() {
      this.otherClinicList = []
      this.otherclinicservice.GetOtherClinic(this.patientcode).subscribe((data:OtherClinicModel[]) =>
     {
      for (let i = 0; i < data.length; i++)
      {
      this.otherClinicList[i] = data[i];
      this.otherClinicList[i].patientcode = data[i].patientcode;
      this.otherClinicList[i].clinicdate = data[i].clinicdate;
      this.otherClinicList[i].cliniclocation=data[i].cliniclocation;
      this.otherClinicList[i].clinicnotes = data[i].clinicnotes;
      this.otherClinicList[i].docdepartment = data[i].docdepartment;
      this.otherClinicList[i].username = data[i].username;
      this.otherClinicList[i].clinicdate = formatDate(data[i].clinicdate, 'yyyy-MM-dd', 'en');
      this.companyService.getcompany(data[i].cliniclocation).subscribe((data: CompanyModel) => {

                                     this.cliniclocationtext[i] = data.compName;

                                 });
     }
     });
    }
    openDialog(){
      debugger;
      this.doctorsService.getdoctors(this.storage.retrieve('stgEmpId'),'1').subscribe((data :DoctorsModel)=>{
      this.docDepartment = data.docDepartment;
     })

      console.log("Department :",this.storage.retrieve('stgdocDepartment'),"-",this.docDepartment )
    if(this.storage.retrieve('stgdocDepartment') === 'Oncology' || this.storage.retrieve('stgdocDepartment')  === 'Pharmaceutical' || this.storage.retrieve('stgdocDepartment')  === '' ||this.storage.retrieve('stgdocDepartment')  === null){return this.MesgAddWarrning()};

    if(this.patientcode !='0000' && this.patientcode != ''){



          var wk_Date =formatDate(new Date(), 'yyyy-MM-dd', 'en')
          this.storage.store('stgConsultant',this.docCode);

            this.storage.store('stgVisitDate',wk_Date )
             const dialogRef = this.dialogref.open(OtherclinicentryComponent,
               {
                 data: {
                  dataKey: this.clinicnotes,
                  patientcode : this.patientcode,
                  Patientname : this.storage.retrieve('stgPatientName'),
                  progdate :wk_Date,
                  useridid : this.storage.retrieve('stgUserId'),
                  docCode : this.storage.retrieve('stgConsultant'),
                  username :this.storage.retrieve('stgUsername')
                 },
                 width: '50vw',
                 height: '30vw',
               });
               dialogRef.afterClosed().subscribe(result => {
               this.RetriveOtherClinic();
             });

             const dialogSubmitSubscription =
               dialogRef.componentInstance.submitClicked.subscribe(result => {
                 this.RetriveOtherClinic();
                dialogSubmitSubscription.unsubscribe();
               });
              }


        }

DeleteOtherClinic (){
  this.otherclinicservice.DeleteOtherClinic(this.storage.retrieve('stgPatientCode'),this.storage.retrieve('stguserid'),this.storage.retrieve('stgdocDepartment'),this.storage.retrieve('stgVisitDate')).subscribe((data: OtherClinicModel)=>{
  this.RetriveOtherClinic();
  });
  this.RetriveOtherClinic();
}
      MesgWarrning(){

        swal({
          title: 'Check User',
          text:'Editing or deleting this medical record  is not allowed ',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          //cancelButtonText: 'No, keep it',
        })
        ;

      }
      MesgAddWarrning(){

        swal({
          title: 'Check Department',
          text:'Adding to  this medical record  is not allowed for your Department',
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: 'OK',
          //cancelButtonText: 'No, keep it',
        })
        ;

      }
MessegeDelete(clinic :OtherClinicModel){
  debugger;
    if( clinic.username !== this.storage.retrieve('stgusername') ){return this.MesgWarrning()}

      swal({
        title: 'Are you sure?',
        text: 'You will not be able to recover this record!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then(
        () => {
          this.storage.store('stgPatientCode',clinic.patientcode);
          this.storage.store('stgVisitDate',clinic.clinicdate);
          this.storage.store('stgDocDepartment',clinic.docdepartment)
          this.storage.store('stguserid',clinic.userid)

          this.DeleteOtherClinic();
          swal('Deleted!', 'Your record has been deleted.', 'success');
        },
        function (dismiss) {
          if (dismiss === 'cancel') {
            swal('Cancelled', 'Your record is safe :)', 'error');
          }
        }
      );

    }


    retriveOtherClinicLine (){
      this.otherclinicservice.getotherclinicline(this.patientcode,this.docDepartment,this.clinicdate).subscribe((data : OtherClinicModel)=>{
      this.patientcode = data.patientcode;
      this.clinicdate = data.clinicdate;
      this.cliniclocation=data.cliniclocation;
      this.clinicnotes = data.clinicnotes;
      this.docdepartment = data.docdepartment;
      this.username = data.username;
      this.clinicdate = data.clinicdate
      } );
    }

     Editotherclinic(clinic: OtherClinicModel){
        //   this.chkuser = clinic.username;
         if(this.storage.retrieve('stgdocDepartment') === 'Oncology' || this.storage.retrieve('stgdocDepartment')  === 'Pharmaceutical' || this.storage.retrieve('stgdocDepartment')  === '' ){return this.MesgWarrning()};
         if( clinic.username !== this.storage.retrieve('stgusername')){return this.MesgWarrning()}
        //   {
        //   if(this.storage.retrieve('stgGroup') == '8'){
        //     this.storage.store('stgUserIdId',clinic.userid);
        //     this.storage.store('stgUsernamename',clinic.username);
        //   }else
        //   {
        //     this.storage.store('stgUserIdId','')
        //     this.storage.store('stgUsernamename','');
        //   };


          const dialogRef = this.dialogref.open(OtherclinicentryComponent,
            {
              data: {
                dataKey: this.otherclinic,
                patientcode : clinic.patientcode,
                Patientname : this.storage.retrieve('stgPatientName'),
                progdate : clinic.clinicdate,
                clinicnotes : clinic.clinicnotes,
                docdepartment : clinic.docdepartment,
                usename : clinic.username,
                username : this.storage.retrieve('stgUsernamename'),
                useridid : this.storage.retrieve('stgUserIdId')
              },
              width: '80%',
              height: '80%',
            });
          dialogRef.afterClosed().subscribe(result => {
          this.RetriveOtherClinic();
          });

          const dialogSubmitSubscription =
            dialogRef.componentInstance.submitClicked.subscribe(result => {
              this.RetriveOtherClinic();
              dialogSubmitSubscription.unsubscribe();
            });
          }
          // else{
          //     this.MesgWarrning()
          // }
        }






